export class Card {
    constructor(options = {}) {
        this.el = options.el;
        if (!this.el) {
            throw Error('Необходимо передать элемент');
        }

        this.product = null;
        this.initProduct();

        this.buyBlock = this.el.querySelector('[data-card-buyblock]');
        this.detailLinkBlock = this.el.querySelector('[data-card-detaillink]');
    }

    getProductId() {
        return this.el.dataset.productId;
    }

    async initProduct() {
        const productId = this.getProductId();
        if (!productId) {
            return;
        }

        this.product = await BX.Asteq?.Catalog?.Product.getInstanceAsync(productId);
        if (this.product) {
            this.product.subscribe('offerChange', this.onProductOfferChange.bind(this));
        }
    }

    onProductOfferChange(e) {
        const eventData = e.getData();
        const newOffer = eventData.newOffer;
        if (this.buyBlock) {
            this.buyBlock.style.display = newOffer.displayCanBuy
                ? null
                : 'none';
        }

        if (this.detailLinkBlock) {
            this.detailLinkBlock.style.display = newOffer.displayCanBuy
                ? 'none'
                : null;
        }
    }

    static init(options = {queryElement: document}) {
        options.queryElement.querySelectorAll('[data-local-component="card"]')
            .forEach((el) => {
                new this({
                    el
                });
            });
    }
}

BX.ready(() => {
    Card.init();
});
